<div class="small-banner d-flex align-items-center">
  <div class="col-12 col-md-6 left-text">
    ANALYTICAL SUPPORT
  </div>
  <div class="col-12 col-md-6 right-text">
    Get support from the American Heart Association’s Data Science Team
  </div>
</div>